const DEFAULT_URL = "/version.json";
const DEFAULT_POLL_MS = 30 * 60 * 1_000;
/** Default `BroadcastChannel` name the deployment monitor listens on for `{ type: "latest", version }`. */
export const DEPLOYMENT_CHANNEL = "artis-deployment";
const fetchVersion = async (url, fetchImpl) => {
    const response = await fetchImpl(`${url}?t=${Date.now()}`, { cache: "no-store" });
    if (!response.ok)
        throw new Error(`deployment check failed: HTTP ${response.status}`);
    const { version } = (await response.json());
    if (typeof version !== "string")
        throw new Error("deployment check failed: missing version field");
    return version;
};
/**
 * Keep a {@link DeploymentStore} up to date with the newest deployed version. Fetches the
 * manifest on start, on every `pollMs`, and whenever the document becomes visible, and
 * shares each fetched version with sibling windows over a `BroadcastChannel`. Only the
 * version travels between windows; each one compares it against its own `current`.
 *
 * @returns a function that stops polling, detaches the listeners and closes the channel.
 */
export const startDeploymentMonitor = ({ store, url = DEFAULT_URL, pollMs = DEFAULT_POLL_MS, channelName = DEPLOYMENT_CHANNEL, onError = () => { }, fetch = globalThis.fetch, }) => {
    const channel = typeof BroadcastChannel === "undefined" ? undefined : new BroadcastChannel(channelName);
    const onMessage = (event) => {
        const data = event.data;
        if (data?.type === "latest" && typeof data.version === "string")
            store.applyLatest(data.version);
    };
    channel?.addEventListener("message", onMessage);
    const check = async () => {
        try {
            const latest = await fetchVersion(url, fetch);
            store.applyLatest(latest);
            channel?.postMessage({ type: "latest", version: latest });
        }
        catch (error) {
            onError(error);
        }
    };
    const doc = typeof document === "undefined" ? undefined : document;
    const onVisibility = () => {
        if (doc?.visibilityState === "visible")
            void check();
    };
    doc?.addEventListener("visibilitychange", onVisibility);
    if (!doc || doc.visibilityState === "visible")
        void check();
    const interval = setInterval(check, pollMs);
    return () => {
        clearInterval(interval);
        doc?.removeEventListener("visibilitychange", onVisibility);
        channel?.removeEventListener("message", onMessage);
        channel?.close();
    };
};
//# sourceMappingURL=deploymentMonitor.js.map